import React from 'react'
import { Link, IndexLink } from 'react-router'
import * as firebase from "firebase";

export default class Navigation extends React.Component {
    constructor() {
        super();
        this.state = {isLoggedIn: false};
        this.renderSignOut = this.renderSignOut.bind(this);
        this.componentWillMount = this.componentWillMount.bind(this);
        this.addUser = this.addUser.bind(this);
        this.render = this.render.bind(this)

    }
    componentWillMount() {
        this.checkSignedIn()
    }
    signOut(){
        console.log("signing user out");
        alert("signing out");
        firebase.auth().signOut().then(function() {
            // Sign-out successful.
        }).catch(function(error) {
            // An error happened.
        });

    }
    handleSignOut(){
        console.log("signing user out");
        alert("signing out");

    }
    checkSignedIn(){
        var state = this
        firebase.auth().onAuthStateChanged(function(user) {
            if (user) {
                console.log("singed in : "+ user.phoneNumber);
                state.setState({isLoggedIn:true});
                this.addUser(user.phoneNumber.replace(/\D/g, ''));


            }else {
                console.log("singed out  ");
                state.setState({isLoggedIn:false});
            }
            this.render();
        }.bind(this));
    }
    addUser(userID){
        firebase.database().ref('users/'+userID+'/user/').set(true);
        firebase.database().ref('users/'+userID+'/last_active/').set(new Date().getTime());


    }
    renderSignOut(){


        if(this.state.isLoggedIn){
            return  <div id="nav_sign" ><button id="nav_sign_out" onClick={this.signOut}>Sign Out</button></div>
        }else {
            return <div id="nav_sign" > <div id="firebaseui-auth-container"></div></div>

        }

    }
  render () {
    return (
        <nav id = "nav_bar" className="navbar navbar-default navbar-static-top">
          <a className="navbar-brand" id = "nav_home" href="/">Texter</a>
          <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
              {this.renderSignOut()}
              <ul className="nav navbar-nav">
            </ul>
          </div>
        </nav>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/header/Navigation.jsx